import { render, staticRenderFns } from "./DefaultItem.vue?vue&type=template&id=e3a7f348"
import script from "./DefaultItem.vue?vue&type=script&lang=js"
export * from "./DefaultItem.vue?vue&type=script&lang=js"
import style0 from "./DefaultItem.vue?vue&type=style&index=0&id=e3a7f348&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports